import styled from "styled-components"
import { Grid, ButtonGroup } from "@material-ui/core"
import left_pano from "./images/left_pano.png"
import middle_pano from "./images/middle_pano.png"
import right_pano from "./images/right_pano.png"

export const GroupButton = styled(ButtonGroup)`
  .MuiButtonGroup-grouped {
    ${(props) => props?.minWidth && `min-width: ${props.minWidth};`};
  }
`

export const StyledShekelMainWrapper = styled(Grid)`
  font-family: "arial";
  position: relative;
  &.cls-theme-1 {
    max-width: 1194px;
  }
  &.cls-theme-2 {
    max-width: 2350px;
    width: 100%;
  }

  &.editmode {
  }
  &.viewmode {
    .cls-action-item {
      display: none !important;
      cursor: none !important;
    }

    .cls-qty-dropdown-btn-kit {
      pointer-events: none !important;
    }
    .cls-input-count {
      pointer-events: none !important;
      background: #d8d8d8 !important;

      input {
        font-weight: bold !important;
      }
    }
    .cls-minus-count,
    .cls-plus-count {
      opacity: 0.5 !important;
      pointer-events: none !important;
    }
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
`
export const StyledShekelRowMainWrapper = styled(Grid)`
  width: 100%;
  border-radius: 6px;
  min-height: 300px;
  padding-top: 5px;
  margin-bottom: 15px;
  box-sizing: border-box;
  &.cls-theme-1 {
    background-image: url(${right_pano}), url(${left_pano}), url(${middle_pano});
    background-repeat: no-repeat, no-repeat, repeat;
    background-position: left, right, center;
    height: 360px;
    .cls-StyledShekelRowWrapper {
      max-width: 1000px !important;
      margin: auto;
    }
  }
  &.cls-theme-2 {
     height: initial;
    &.cls-theme-2-multiproduct {
      height: 480px;
      min-height: 480px;
      &.cls-theme-2-multiproduct-smc {
        height: 410px;
        min-height: 410px;
      }
    }
    .cls-StyledShekelRowWrapper {
      max-width: 2350px !important;
      width: 100% !important;
      border: 1px solid #e8e8e8;
      border: 2px solid #e5d8e6;
    }
     @media (max-width: 580px) {
      height: initial !important;
      &.cls-theme-1 {
        height: initial !important;
      }
      &.cls-theme-2 {
      height: initial !important;
      }
       &.cls-theme-2-multiproduct {
      height: initial !important;
      min-height: initial !important;
      &.cls-theme-2-multiproduct-smc {
        height: initial !important;
        min-height: initial !important;
      }
    }
    },
  }
`
export const StyledShekelRowWrapper = styled(Grid)`
  width: 100%;
  max-width: 1100px;
  border-radius: 6px;
  min-height: 280px;
  border: 0px solid #c1c1c1;
  margin-top: 6px;
  background: #fff;
`
export const StyledShekelRowHeaderWrapper = styled(Grid)`
  width: 100%;
  border-radius: 4px;
  min-height: 45px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  background: #e8e8e8;
  background: #e5d8e6;

  .cls-skl-left-panl {
    font-weight: bold;
    font-size: 14px;
    display: flex;
    padding-left: 15px;
    padding-right: 15px;
    align-items: center;
  }

  @media (min-width: 900px) and (max-width: 1200px) {
  }
  @media (min-width: 300px) and (max-width: 900px) {
    flex-direction: column;
  }
    @media (max-width: 600px) {
  .cls-skl-left-panl {
    flex-direction: column;
    align-items: center;
  }
}
`
export const StyledShekelRowEmptyWrapper = styled("h2")`
  font-weight: normal !important;
  font-size: 17px !important;
  padding: 24px;
  color: #818181;
  text-align: center;
`
export const StyledShekelRowInnerCellWrapper = styled(Grid)`
  display: flex;
  flex-direction: row;
  width: 100%;
    @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const StyledShekelRowContentWrapper = styled(Grid)`
  width: auto;
  height: 100%;
  min-height: 235px;
  padding: 10px;
  overflow: auto;
  padding-bottom: 0px;
  &.cls-wrapper-multiproduct {
    min-height: 390px;
    &.cls-wrapper-multiproduct-smartcooler {
      min-height: 340px;
    }
  }
`

export const StyledShekelCellCardWrapper = styled(Grid)`
  padding: 10px;
  background: #fff;
  border-radius: 6px;
  ${(props) => {
    let cellCount = Number(props.cellCount)
    if (cellCount <= 3) {
      return `min-width:${Math.floor(100 / cellCount)}%;`
    } else {
      // return "min-width: 430px;"
      return "min-width: 461px;"
    }
  }};
  min-height: 200px;
  border: 1px solid #c1c1c166;
  font-family: "arial";
  margin-right: 10px;
  margin-right: 10px;
  box-shadow: 0px 2px 3px #00000033;
  margin-bottom: 9px;

  &.cls-multiproduct-kit {
    min-height: 383px;
    &.cls-multiproduct-smartcooler-kit {
      min-height: 320px;
    }
  }

  .cls-ShekelCardContProductMultipleWrapper {
    display: flex;
    flex-direction: row;
    overflow: auto;
    min-height: 250px;
    width: auto;
    min-width: 315px;
    background: #f3f7fa;
  }

  .cls-ShekelCardContProductWrapper-dnd {
    cursor: grab;
    margin-right: 12px;
    font-size: 22px;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 3px;
    z-index: 99;
    left: 0;
    right: 0;
    margin: auto;
    width: 30px;
    height: 12px;
    background-size: 100% !important;
    background-repeat: no-repeat !important;
  }
  .cls-ShekelCardContProductWrapper.cls-value {
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    min-height: 180px;
    &.cls-multiple {
      margin: 10px;
      min-width: 298px;
      max-width: 416px;
      padding-right: 10px;
      margin-right: 10px;
      min-height: 200px !important;
      max-height: 200px !important;
      background: #fff;
      border-radius: 10px;
      border: 1px solid #c9b5cb;
     @media (max-width: 600px) {
       min-width: 100%;
      max-width: 100%;
       min-height: initial !important;
      max-height: initial !important;
      .MuiGrid-root {
        .MuiGrid-root{
        flex-direction: column !important;
        align-items: center;
        text-align: center;
        }
      }
    }
  }
  .cls-ShekelCardContProductInfoAction {
    position: absolute;
    right: 5px;
    bottom: 5px;
    &.cls-alone {
      top: 3px;
      bottom: unset;
    }
    &.cls-multiple {
      width: 100%;
      background: #fafbfd;
      height: 35px;
      bottom: 0px;
      right: 0px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      box-shadow: 10px 10px 18px #000;
      position: relative;
    }
  }

  div,
  img {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  .cls-ShekelCardContProductimage {
    ${(props) => {
    let cellCount = Number(props.cellCount)
    if (cellCount === 3) {
      return `
              min-width: 85px;
              min-height: 170px;
              & > img {
                transform: scale(0.6);
                transform-origin: center;
              }
            `
    } else {
      return `
              min-width: 85px;
              min-height: 170px;
              max-width: 188px;
              max-height: 170px;
            `
    }
  }};
    border-radius: 6px;
    border: 1px solid #ccc;
    padding: 4px;
    /* overflow: hidden; */
    background: #fff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &.cls-multiple-image {
      width: auto;
    }

    &::before {
      content: "";
      width: 100%;
      height: 100%;
      box-shadow: inset 0px 0px 12px #00000047;
      position: absolute;
      left: 0;
      top: 0;
    }

    & img {
      width: auto;
      height: auto;
      margin: auto;
      display: flex;
      max-width: 150px;
      max-height: 150px;
      border-radius: 5px;
    }
  }
  .cls-ShekelCardContProductInfokit {
    padding: 10px;
    box-sizing: border-box;
    padding-top: 0px;
    width: auto;
    min-width: 200px;
    display: flex;
    flex-direction: column;
  }
  .cls-ShekelCardContProducttitle {
    font-size: 13px;
    color: #000;
    font-weight: bold;
    margin-bottom: 0px;
    word-wrap: break-word;
    width: 180px;
    min-height: 18px;
    max-height: 57px;
    --line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: var(--line-clamp);
    -webkit-box-orient: vertical;
    &.cls-multiple {
      width: 126px;
      margin-bottom: 0px;

      &.product-title {
        width: 160px;
      }
    }
  }
  .cls-ShekelCardContProductitemid {
    font-size: 12px;
    color: #656565;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px;
    &.cls-multiple {
      width: 126px;
      margin-bottom: 4px;
    }
  }
  .cls-ShekelCardContProductweight {
    font-size: 12px;
    color: #656565;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px;
    &.cls-multiple {
      width: 126px;
    }
  }
  .cls-ShekelCardContProductWrapper.cls-empty {
    justify-content: center;
    align-items: center;
    min-height: 180px;
    height: 180px;
    &.cls-empty-multiple {
      min-height: 250px;
      height: 250px;
    }
  }
`
export const StyledShekelCardCameraWrapper = styled(Grid)`
  background: #eff2f1;
  border-radius: 6px;
  width: 100%;
  height: 35px;
  font-family: "arial";
  margin-right: 10px;

  button {
    display: flex;
    margin: auto;
    width: 100%;
  }
`
export const StyledShekelCardCameraValWrapper = styled(Grid)`
  background: #bcd6cf;
  border-radius: 6px;
  width: 100%;
  height: 35px;
  font-family: "arial";
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  box-sizing: border-box;

  &.cls-two-camera {
    background: #c8ee77;
  }
  &.cls-no-camera {
    background: #ddcaca;
  }

  button {
    width: 24px;
    height: 24px;
    padding: 0px;
    margin-left: 4px;
  }

  @media (min-width: 900px) and (max-width: 1200px) {
    overflow: hidden;
  }
  @media (min-width: 300px) and (max-width: 900px) {
    overflow: hidden;
  }
`
export const StyledShekelCardProductWrapper = styled(Grid)`
  background: #fafbfd;
  border-radius: 6px;
  width: 100%;
  min-height: 158px;
  font-family: "arial";
  margin-right: 10px;
  margin-top: 10px;
  border: 1px solid #e5d9e6;
  overflow: hidden;

  .cls-ShekelCardHeadProductWrapper {
    width: 100%;
    min-height: 40px;
    background: #e5d9e6;

    .cls-delete-emptyicon-kit {
      display: flex;
      margin: auto;
    }
  }

  .cls-ShekelCardContProductWrapper {
    display: flex;
    min-height: 102px;
    width: 100%;
    position: relative;
  }
  .cls-ShekelCardAddProductWrapper {
    border: 1px solid #c1c1c1;
    border-radius: 6px;
    height: 40px;
  }
`
export const StyledShekelCardProductValWrapper = styled(Grid)`
  background: #fafbfd;
  border-radius: 6px;
  width: 100%;
  min-height: 173px;
  font-family: "arial";
  margin-right: 10px;
  margin-top: 10px;
  border: 1px solid #e5d9e6;
  overflow: hidden;
  position: relative;

  .cls-ShekelCardHeadProductWrapper {
    width: 100%;
    min-height: 40px;
    background: #e5d9e6;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
  }
  .cls-ShekelCardContProductWrapper {
    display: flex;
     min-height: 331px;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .cls-ShekelCardAddProductWrapper {
    border: 1px solid #c1c1c1;
    border-radius: 6px;
    height: 40px;
  }
  .cls-ShekelCardCellValue {
    background: #99378d;
    min-width: 29px;
    color: #fff;
    padding: 3px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .cls-ShekelCardCellInfo {
    height: 100%;
    color: #000;
    padding: 3px;
    box-sizing: border-box;
    display: flex;
    margin-right: 10px;
    flex-direction: column;
    max-width: 165px;
    min-width: 100px;
    &.cls-remaining-width {
      max-width: 120px;
      div {
        color: #99378d !important;
        font-weight: bold !important;
      }
    }
  }
  .cls-ShekelCardCellInfoRow {
    height: 100%;
    color: #000;
    padding: 3px;
    box-sizing: border-box;
    display: flex;
    margin-right: 3px;
    flex-direction: row;
    max-width: 80px;
    justify-content: flex-end;
  }
  .cls-ShekelCardCellInfo-parent {
    width: fit-content;
    height: 100%;
    display: flex;
    &.cls-non-Associate {
      width: auto;
      min-width: 95px;
      max-width: 151px;

      .cls-ShekelCardCellInfo {
        width: 100% !important;
        max-width: 100% !important;
        flex-direction: row !important;
        align-items: center !important;

        .cls-cell-key {
          margin-right: 8px;
        }
      }
    }
  }

  .cls-cell-key {
    text-align: center;
    font-size: 10px;
    margin-bottom: 0px;
    &.cls-text-kit {
      text-align: left;
      word-wrap: break-word;
    }
  }
  .cls-cell-value {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    &.cls-text-kit {
      font-size: 12px;
      text-align: left;
      word-wrap: break-word;
      overflow: hidden;
    }
  }
`
